export enum SettingsType {
    Number = 'NUMBER',
    String = 'STRING',
    Boolean = 'BOOLEAN',
    Array = 'ARRAY',
    Object = 'OBJECT',
}

export enum Settings {
    AuctionAutoStrategySettings = 'auction.auto_strategy_settings',
    BlocklistCampaignCreating = 'front.blocklist_campaign_creating',
    VkadsLeadFormAccountIds = 'vkads.leadform.accountIds',

    CampaignsDashboardRedesignAllowed = 'employer.campaigns_dashboard_redesign_allowed',

    AiGenerationProfrolesBlacklist = 'ai_generation.profroles.blacklist',
    AiImageGenerationEnabled = 'ai_image_generation_enabled',
    DiscountedMinBudget = 'budget.discounted_min_budget',
    DiscountedMinDailyBudget = 'budget.discounted_min_daily_budget',
    EnableBannerTextGeneration = 'enable_banner_text_generation',
    EnableUploadVideoForYandex = 'enable_upload_video_for_yandex',
    EnableQuiz = 'enable_quiz',
    EnableUserRefund = 'user_refund.enabled',
    EnableUxfeedback = 'enable_uxfeedback',
    EnableYandexVideoBanner = 'enable_yandex_video_banner',
    ErirClassificationEnabled = 'erir.classification_enabled',
    IsHelpModalEnabled = 'is_help_modal_enabled',
    IsUpscaleEnabled = 'is_upscale_enabled',
    NormalMinBudget = 'budget.normal_min_budget',
    NormalMinDailyBudget = 'budget.normal_min_daily_budget',
    WebdavFileMaxSize = 'webdav.file.max_size',
}

export type SettingsConfig = Record<Settings, SettingsType>;

export const SETTINGS_CONFIG: SettingsConfig = {
    [Settings.AuctionAutoStrategySettings]: SettingsType.Object,
    [Settings.BlocklistCampaignCreating]: SettingsType.Boolean,
    [Settings.VkadsLeadFormAccountIds]: SettingsType.Boolean,

    [Settings.CampaignsDashboardRedesignAllowed]: SettingsType.Boolean,

    [Settings.AiGenerationProfrolesBlacklist]: SettingsType.Array,
    [Settings.AiImageGenerationEnabled]: SettingsType.Boolean,
    [Settings.DiscountedMinBudget]: SettingsType.Number,
    [Settings.DiscountedMinDailyBudget]: SettingsType.Number,
    [Settings.EnableBannerTextGeneration]: SettingsType.Boolean,
    [Settings.EnableUploadVideoForYandex]: SettingsType.Boolean,
    [Settings.EnableQuiz]: SettingsType.Boolean,
    [Settings.EnableUserRefund]: SettingsType.Boolean,
    [Settings.EnableUxfeedback]: SettingsType.Boolean,
    [Settings.EnableYandexVideoBanner]: SettingsType.Boolean,
    [Settings.ErirClassificationEnabled]: SettingsType.Boolean,
    [Settings.IsHelpModalEnabled]: SettingsType.Boolean,
    [Settings.IsUpscaleEnabled]: SettingsType.Boolean,
    [Settings.NormalMinBudget]: SettingsType.Number,
    [Settings.NormalMinDailyBudget]: SettingsType.Number,
    [Settings.WebdavFileMaxSize]: SettingsType.Number,
};

export const SETTINGS_LIST = Object.keys(SETTINGS_CONFIG);
